export default __webpack_public_path__ + "static/media/bagIcon.5bd036e0.png";